import { IRecommendation } from 'modules/customer/domain/entities';

export interface IVectisRecommendation {
  id: number;
  dataCadastro: string;
  nome: string;
  ativo: boolean;
}

export class Recommendation implements IRecommendation {
  public id: IRecommendation['id'];
  public name: IRecommendation['name'];
  public createdAt: IRecommendation['createdAt'];
  public active: IRecommendation['active'];

  constructor({ id, nome, dataCadastro, ativo }: IVectisRecommendation) {
    this.id = id;
    this.name = nome;
    this.createdAt = dataCadastro;
    this.active = ativo;
  }
}
